import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { getGroupScopedImpersonation } from "../utils/impersonation"

function ScopedImpersonationGuard() {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    const scope = getGroupScopedImpersonation()
    if (!scope?.groupId) return

    const targetGroupId = String(scope.groupId)
    const currentPath = String(location.pathname || "")

    if (currentPath !== "/app/groups") {
      navigate(`/app/groups?groupId=${encodeURIComponent(targetGroupId)}&view=member`, { replace: true })
      return
    }

    const params = new URLSearchParams(location.search || "")
    const currentGroupId = String(params.get("groupId") || "")
    if (currentGroupId === targetGroupId) return

    params.set("groupId", targetGroupId)
    params.set("view", "member")
    navigate(`/app/groups?${params.toString()}`, { replace: true })
  }, [location.pathname, location.search, navigate])

  return null
}

export default ScopedImpersonationGuard
